
import React from 'react';
import DatePickerComponent from '@/components/booking/DatePickerComponent';
import TimeSlotSelector from '@/components/booking/TimeSlotSelector';
import TimezoneSelector from '@/components/booking/TimezoneSelector';
import { TimeSlot } from '@/utils/timeSlotUtils';

interface DateTimeSelectorProps {
  selectedDate: Date | undefined;
  setSelectedDate: (date: Date | undefined) => void;
  timeSlots: TimeSlot[];
  selectedTimeSlot: TimeSlot | null;
  setSelectedTimeSlot: (timeSlot: TimeSlot) => void;
  disabledDates?: (date: Date) => boolean;
  timezone: string;
  setTimezone: (timezone: string) => void;
}

const DateTimeSelector: React.FC<DateTimeSelectorProps> = ({
  selectedDate,
  setSelectedDate,
  timeSlots,
  selectedTimeSlot,
  setSelectedTimeSlot,
  disabledDates,
  timezone,
  setTimezone
}) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border p-6">
      <h2 className="text-lg font-medium mb-4">Select a Date & Time</h2>
      
      <div className="space-y-6">
        <TimezoneSelector 
          timezone={timezone} 
          setTimezone={setTimezone} 
          className="mb-4"
        />

        <div>
          <label className="block text-sm font-medium mb-2">Date</label>
          <DatePickerComponent 
            date={selectedDate} 
            setDate={setSelectedDate} 
            disabledDates={disabledDates}
          />
        </div>
        
        {selectedDate && (
          <div>
            <label className="block text-sm font-medium mb-2">Available Times</label>
            <TimeSlotSelector 
              timeSlots={timeSlots}
              selectedTimeSlot={selectedTimeSlot}
              onSelectTimeSlot={setSelectedTimeSlot}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default DateTimeSelector;
